export const stringToAlgoliaQuery = (regulatString: string = "") => {
  return regulatString.replaceAll(" ", "+").replaceAll("&", "%26");
};
